/**
 * Kinng.app — Plans API.
 * Endpoints do Painel Mestre + endpoint público.
 */
import api from "./api";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export const plansAdminApi = {
    list:         ()          => api.get("/admin/plans"),
    get:          (id)        => api.get(`/admin/plans/${id}`),
    create:       (body)      => api.post("/admin/plans", body),
    update:       (id, body)  => api.patch(`/admin/plans/${id}`, body),
    toggle:       (id)        => api.patch(`/admin/plans/${id}/toggle`, {}),
    distribution: ()          => api.get("/admin/plans/distribution"),
};

// Public — sem auth
export const plansPublicApi = {
    list: async () => {
        const r = await fetch(`${API_BASE}/public/plans`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
    },
};

export default plansAdminApi;
